import { render, staticRenderFns } from "./SelecoesInscricoesTable.vue?vue&type=template&id=2e020200&scoped=true"
import script from "./SelecoesInscricoesTable.vue?vue&type=script&lang=js"
export * from "./SelecoesInscricoesTable.vue?vue&type=script&lang=js"
import style0 from "./SelecoesInscricoesTable.vue?vue&type=style&index=0&id=2e020200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e020200",
  null
  
)

export default component.exports